import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Twitter = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M19.94 8.05c.02.18.02.35.02.53 0 5.42-4.13 11.66-11.67 11.66-2.32 0-4.48-.67-6.29-1.84a8.47 8.47 0 0 0 6.08-1.7 4.1 4.1 0 0 1-3.83-2.84 4.33 4.33 0 0 0 1.85-.08A4.1 4.1 0 0 1 2.8 9.76v-.05c.55.3 1.18.5 1.85.52A4.1 4.1 0 0 1 3.4 4.75a11.65 11.65 0 0 0 8.45 4.29 4.1 4.1 0 0 1 7-3.74 8.07 8.07 0 0 0 2.6-1c-.31.96-.96 1.76-1.81 2.26A8.22 8.22 0 0 0 22 5.93a8.81 8.81 0 0 1-2.06 2.12Z"
    />
  </svg>
));
